import React from 'react'
import MobileDrawer from '../MobileComponents/MobileDrawer';
import resipro from '../../assets/images/resiproIcon.svg';
import { useNavigate } from 'react-router-dom';

function MobileFoodOrderOption() {
  const navigate = useNavigate();
  return (
    <div className='mainwrapperView'>
    <div className="drawerWithTop">
        <MobileDrawer />
        <div className="EventTimeView">
          <img src={resipro} className="HeaderlogoImage" alt='altimg'/>
          <h2 className="mobHeadHeading">Park Side Apartment</h2>
        </div>
    </div>
    <div className='topSpace'></div>
    <div className='MarketBtnSearchView'>
        <div className='foodBtnView' onClick={()=>navigate('/MobileFoodOrder')}>
            <p className='foodBtnTxt'>Food Order</p>    
        </div>
        <div className='foodBtnView' onClick={()=>navigate('/MobileMyOrder')}>
            <p className='foodBtnTxt'>My Order</p>    
        </div>
    </div>
    </div>
  )
}

export default MobileFoodOrderOption